import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { useArrivedIncompleteStyles } from './styles';
import { schema } from './validation/schema';
import AppInput from '../../../../../../common/AppInput';
import AuthorizeCheckbox from '../authorizeThird/AuthorizeCheckbox';
import LoadingButton from '../../../../../../common/LoadingButton';
import { bodyTicketProductGenerator } from '../../../../../../../helpers/tickets/TicketsHelper';
import { createTicketNoProduct } from '../../../../../../../redux/actions/TicketActions';

const ArrivedIncomplete = ({ ...props }) => {
  const { mobile, motiveId, product, type, profile } = props;
  const classes = useArrivedIncompleteStyles({ mobile });
  const [description, setDescription] = useState('');
  const [descriptionValidation, setDescriptionValidation] = useState('');
  const [missingPart, setMissingPart] = useState('');
  const [missingPartValidation, setMissingPartValidation] = useState('');
  const [checked, setChecked] = useState(false);
  const [errorMessageDescription, setErrorMessageDescription] = useState('');
  const [errorMessageMissingPart, setErrorMessageMissingPart] = useState('');
  const [helperDescription, setHelperDescription] = useState('0/250');
  const [helperMissingPart, setHelperMissingPart] = useState('0/100');

  const { ticketNoProductStatus } = useSelector((state) => state.ticketReducer);
  const dispatch = useDispatch();

  const handleLengthInputs = (e) => {
    const { name, value } = e.target;
    const max = name == 'descriptionInput' ? 250 : 100;
    const setValue =
      name == 'descriptionInput' ? setDescription : setMissingPart;
    const setHelper =
      name == 'descriptionInput' ? setHelperDescription : setHelperMissingPart;

    if (value.length <= max) {
      setValue(value);
      setHelper(`${value.length}/${max}`);
    }
  };

  const handleValidation = (e) => {
    const { name } = e.target;
    const joiProp =
      name == 'descriptionInput' ? { description } : { missingPart };
    const setErrorMessage =
      name == 'descriptionInput'
        ? setErrorMessageDescription
        : setErrorMessageMissingPart;
    const setValidation =
      name == 'descriptionInput'
        ? setDescriptionValidation
        : setMissingPartValidation;

    if ('error' in schema.validate(joiProp)) {
      setValidation('error');
      setErrorMessage(schema.validate(joiProp).error.message);
    } else {
      setValidation('valid');
      setErrorMessage('');
    }
  };

  const sendData = () => {
    const body = {
      faltante_declarado: missingPart,
      ...bodyTicketProductGenerator({
        profile,
        type,
        motiveId,
        product,
        comment: description,
      }),
    };
    dispatch(createTicketNoProduct(body));
  };

  return (
    <Box className={classes.container}>
      <AppInput
        required
        name="missingPartInput"
        label="¿Qué faltó?"
        value={missingPart}
        onClick={() => {}}
        onChange={handleLengthInputs}
        onBlur={handleValidation}
        errorMessage={errorMessageMissingPart}
        success={missingPartValidation === 'valid'}
        error={missingPartValidation === 'error'}
        helperText={helperMissingPart}
      />
      <AppInput
        required
        multiline
        name="descriptionInput"
        label="Cuéntanos…"
        value={description}
        onClick={() => {}}
        onChange={handleLengthInputs}
        onBlur={handleValidation}
        errorMessage={errorMessageDescription}
        success={descriptionValidation === 'valid'}
        error={descriptionValidation === 'error'}
        helperText={helperDescription}
      />
      <AuthorizeCheckbox
        idComplement="ArrivedIncomplete"
        onCheck={() => setChecked(!checked)}
        disabled={
          descriptionValidation !== 'valid' || missingPartValidation !== 'valid'
        }
      />
      <LoadingButton
        name="ArrivedIncomplete"
        text="Enviar"
        disabled={
          !checked ||
          descriptionValidation !== 'valid' ||
          missingPartValidation !== 'valid'
        }
        className={classes.sendButton}
        variant="contained"
        color="primary"
        loading={ticketNoProductStatus === 'loading'}
        onClick={sendData}
        data-cy="ArrivedIncomplete"
      />
    </Box>
  );
};

ArrivedIncomplete.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  onData: PropTypes.func,
};

export default ArrivedIncomplete;
